/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Imagealt1Inputs */

const en_gc_search_guides_what_is_gridcraft_imagealt1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Imagealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft spreadsheet displaying a sales table and two charts`)
};

const zh_gc_search_guides_what_is_gridcraft_imagealt1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Imagealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 电子表格显示销售数据表和两张图表`)
};

/**
* | output |
* | --- |
* | "GridCraft spreadsheet displaying a sales table and two charts" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Imagealt1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_imagealt1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Imagealt1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Imagealt1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_imagealt1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_imagealt1(inputs)
});
export { gc_search_guides_what_is_gridcraft_imagealt1 as "gc.search_guides.what_is_gridcraft.imageAlt" }